import { DynamicRoutingReducer } from '../dynamic-routing.model';
import { Actions, ActionTypes } from './dynamic-routing.action';

export const initialState: DynamicRoutingReducer = {
  existing_tunnel_configs: [],
  configs: [],
};

export function dynamicRoutingReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_DYNAMIC_ROUTING_CONFIGURATION:
      return {
        ...state,
        configs: [...action.payload.configs],
      };

    case ActionTypes.SET_EXISTING_TUNNEL_CONFIGURATION:
      return {
        ...state,
        existing_tunnel_configs: [...(action.payload || [])],
      };

    case ActionTypes.ADD_DYNAMIC_ROUTING_CONFIGURATION:
      return {
        ...state,
        configs: [...state.configs, action.payload],
      };

    case ActionTypes.UPDATE_DYNAMIC_ROUTING_CONFIGURATION:
      return {
        ...state,
        configs: state.configs.map((config) =>
          config.id === action.payload.id ? { ...config, ...action.payload } : config
        ),
      };

    case ActionTypes.DELETE_DYNAMIC_ROUTING_CONFIGURATION:
      return {
        ...state,
        configs: state.configs.filter((staticHost) => !action.payload.includes(staticHost.id)),
      };

    case ActionTypes.CLEAR_DYNAMIC_ROUTING_CONFIGURATION:
      return {
        ...state,
        configs: [],
      };

    case ActionTypes.CLEAR_EXISTING_TUNNEL_CONFIGURATION:
      return {
        ...state,
        existing_tunnel_configs: [],
      };

    default:
      return state;
  }
}
